

var _squid = require('squid');

require('./directive');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$XOSepaRoute', function () {

    return _squid.$ComponentRoute.extend('SepaRoute', {

        name: 'sepa',
        directive: 'xo-sepa',
        titleContent: 'DEMemberGuest.sepaTitle',
        trackingData: {
            fptiState: 'sepa_mandate',
            buzname: {
                'fullpage': {
                    'pagename': '%::sepa_mandate',
                    'pagename2': '%::sepa_mandate:member:hermes:',
                    'version': 'member:%:'
                }
            }

        },
        loginRequired: true,
        children: []
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-bank/sepa/route.js
// module id = ../node_modules/xo-wallet-components/src/add-bank/sepa/route.js
// module chunks = 0